import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories, faqList, homeStats, homeFeatures, testimonials } from '@/mocks/articles';

const featuredContent = [
  {
    id: 1,
    title: '2024年度精选剧情大片合集',
    category: '剧情大片',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20movie%20poster%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20film%20noir%20aesthetic%2C%20vintage%20cinema%20atmosphere%2C%20artistic%20composition%20with%20silhouettes%2C%20professional%20movie%20poster%20design&width=640&height=360&seq=featured-1&orientation=landscape',
    slug: '2024-nian-du-jing-xuan-ju-qing-da-pian',
    duration: '15:24',
    views: 12580,
  },
  {
    id: 2,
    title: '街头美食探店：老城区的隐藏美味',
    category: '生活时尚',
    image: 'https://readdy.ai/api/search-image?query=Delicious%20street%20food%20close%20up%20photography%20with%20steam%20rising%2C%20warm%20amber%20lighting%2C%20bustling%20night%20market%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20rich%20textures%20and%20colors%2C%20editorial%20food%20photography&width=640&height=360&seq=featured-2&orientation=landscape',
    slug: 'mei-shi-tan-dian-ji-shi-cheng-shi-wei-lei-tu-jian',
    duration: '12:08',
    views: 18340,
  },
  {
    id: 3,
    title: '原创音乐人新秀专场Live',
    category: '音乐现场',
    image: 'https://readdy.ai/api/search-image?query=Live%20music%20concert%20stage%20with%20dramatic%20spotlight%20and%20atmospheric%20haze%2C%20musician%20performing%20with%20passion%2C%20warm%20and%20cool%20light%20contrast%2C%20concert%20photography%20aesthetic%2C%20emotional%20performance%20moment&width=640&height=360&seq=featured-3&orientation=landscape',
    slug: 'yuan-chuang-yin-le-ren-xin-xiu-zhuan-chang',
    duration: '22:45',
    views: 9870,
  },
  {
    id: 4,
    title: '2026旗舰手机深度对比评测',
    category: '科技数码',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20smartphone%20product%20photography%20on%20minimalist%20surface%2C%20elegant%20lighting%20with%20soft%20shadows%2C%20premium%20tech%20aesthetic%2C%20clean%20composition%2C%20professional%20commercial%20photography%20style&width=640&height=360&seq=featured-4&orientation=landscape',
    slug: 'ke-ji-shu-ma-xin-pin-shen-du-ping-ce',
    duration: '18:30',
    views: 22300,
  },
  {
    id: 5,
    title: '纪录片：被忘的手艺人',
    category: '纪录纪实',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20style%20portrait%20of%20elderly%20artisan%20in%20traditional%20workshop%2C%20warm%20natural%20lighting%2C%20weathered%20hands%20working%20on%20craft%2C%20authentic%20cultural%20atmosphere%2C%20cinematic%20documentary%20photography&width=640&height=360&seq=featured-5&orientation=landscape',
    slug: 'ji-lu-pian-bei-wang-de-shou-yi-ren',
    duration: '28:15',
    views: 7650,
  },
  {
    id: 6,
    title: '手机拍摄技巧：零基础入门到精通',
    category: '科技数码',
    image: 'https://readdy.ai/api/search-image?query=Creative%20smartphone%20photography%20setup%20on%20desk%2C%20artistic%20flat%20lay%20composition%2C%20warm%20natural%20lighting%2C%20modern%20creative%20workspace%2C%20photography%20tutorial%20aesthetic%2C%20clean%20and%20inspiring&width=640&height=360&seq=featured-6&orientation=landscape',
    slug: 'shou-ji-pai-she-ji-qiao-ru-men-zhi-nan',
    duration: '10:52',
    views: 20150,
  },
];

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border border-background-200/70 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
      >
        <span className="text-sm font-medium text-foreground-900 pr-4">{question}</span>
        <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500 w-4 h-4 flex items-center justify-center"></i>
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`}>
        <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '麻豆视频',
    url: 'https://zhxnfyygl.cn',
    description: '麻豆视频是备受关注的原创高清内容平台，提供丰富的影视娱乐资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-8888',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '麻豆视频',
    url: 'https://zhxnfyygl.cn',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://zhxnfyygl.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
      />
      <HeroSection />
      <FeaturesSection />
      <CategoriesSection />
      <FeaturedSection />
      <StatsSection />
      <TestimonialsSection />
      <FAQSection />
      <NewsletterSection />
    </main>
  );
}

function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20abstract%20background%20with%20soft%20gradients%20of%20deep%20orange%20and%20amber%2C%20artistic%20light%20streaks%20and%20bokeh%20effects%2C%20elegant%20atmospheric%20texture%2C%20modern%20luxurious%20cinema%20aesthetic%2C%20dark%20rich%20tones%20with%20warm%20highlights&width=1920&height=800&seq=madou-hero-bg&orientation=landscape"
          alt="麻豆视频 - 高清原创内容平台"
          title="麻豆视频 - 高清原创内容平台官方入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-background-50/90">全新原创内容每日更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            高清原创内容平台
            <span className="block text-accent-300 mt-2">发现无限精彩</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
            麻豆视频汇聚海量高清原创内容，从剧情大片到纪录纪实，从音乐现场到生活时尚，
            为您打造沉浸式观影体验。每日更新，精彩不断。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/drama"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
            >
              立即探索
            </Link>
            <Link
              to="/about"
              className="bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/25 text-background-50 px-8 py-3 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择麻豆视频
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            我们致力于为用户提供最优质的原创内容体验，用心做好每一个细节
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {homeFeatures.map((feature, index) => (
            <div
              key={index}
              className="bg-background-100/70 rounded-xl p-6 hover:bg-background-200/50 transition-colors duration-200 group cursor-default"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            内容分类
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索精彩内容
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大内容分类，满足您不同场景下的观影需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-xl p-5 text-center hover:bg-background-100 transition-all duration-200 group cursor-pointer border border-background-200/60 hover:border-primary-200"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-primary-500 text-xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-3">
          <div>
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-2">
              精选内容
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
          </div>
          <Link
            to="/category/drama"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i></span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.slug}`}
              className="group cursor-pointer bg-background-100/50 rounded-xl overflow-hidden hover:bg-background-100 transition-all duration-200 border border-background-200/60"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 麻豆视频`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    <i className="ri-play-fill text-background-50 text-xl w-5 h-5 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-600 font-medium">{item.category}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-1.5 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i></span>
                    {(item.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-primary-500">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {homeStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/75">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  const testimonialAvatars = [
    'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20with%20warm%20friendly%20smile%2C%20clean%20background%2C%20casual%20style%2C%20natural%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-li&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Young%20Chinese%20professional%20woman%20portrait%20with%20gentle%20smile%2C%20clean%20white%20background%2C%20modern%20office%20attire%2C%20soft%20natural%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-wang&orientation=squarish',
    'https://readdy.ai/api/search-image?query=Chinese%20male%20creative%20professional%20portrait%20with%20confident%20expression%2C%20clean%20background%2C%20artistic%20casual%20style%2C%20warm%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-zhang&orientation=squarish',
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            用户怎么说
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            来自真实用户的评价，您的满意是我们前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={testimonialAvatars[index]}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-3">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            您可能想知道
          </h2>
          <p className="text-sm text-foreground-600">
            关于麻豆视频的常见问题，我们为您一一解答
          </p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}

function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9u40qtca23r0tr1aq1g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！您将第一时间收到最新内容更新通知。');
        setEmail('');
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(errMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-block bg-accent-500/20 text-accent-300 text-xs font-medium px-3 py-1 rounded-full mb-3">
          订阅更新
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          获取最新内容动态
        </h2>
        <p className="text-sm text-foreground-400 mb-8 max-w-md mx-auto">
          订阅麻豆视频新闻简报，第一时间获取最新原创内容、独家活动和会员优惠信息
        </p>

        <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            readOnly
            aria-hidden="true"
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 bg-background-800/50 border border-background-700/50 rounded-lg text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 px-6 py-3 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}